import CustomBreadCrumbs from '@/components/atom/CustomBreadCrumbs';
import MaterialIcon from '@/components/atom/MaterialIcon';
import PaginationComponent from '@/components/common/PaginationComponent';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import NonF2fDoctorItem from '@/components/templates/telemedicine/doctor/components/NonF2fDoctorItem';
import { TelemedicineDoctorsViewModel } from '@/hooks/telemedicine/useTelemedicineDoctorsViewModel';
import theme from '@/styles/theme';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import Link from 'next/link';
import styled, { css } from 'styled-components';

interface Props extends CustomPageProps {
  viewModel: TelemedicineDoctorsViewModel;
}

const TelemedicineDoctorsTemplate = ({ viewModel, client }: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {!client.isMobile && (
        <CustomBreadCrumbs.Wrapper>
          <CustomBreadCrumbs breadCrumbs={viewModel.breadCrumbs} visible />
        </CustomBreadCrumbs.Wrapper>
      )}

      <TemplateLayout.Content>
        <div className={'pb-[80px]'}>
          <HeaderSection>
            <h1 className={'typography-ui-22sb text-gray-900'}>{viewModel.category.name} 비대면 진료</h1>
            <Link href={ROUTES.TELEMEDICINE.CATEGORIES.path}>
              <a className={'flex items-center gap-[4px] rounded-[8px] bg-gray-30 px-[16px] py-[13px]'}>
                <span className={'typography-ui-17m text-gray-700'}>증상/과목 선택</span>
                <MaterialIcon name={'keyboard_arrow_down'} color={theme.color.gray700} size={20} filled />
              </a>
            </Link>
          </HeaderSection>
          <ul className={'flex flex-col'}>
            {viewModel.nonF2fDoctors.map((doctor) => {
              return (
                <li key={`doctor-list-${doctor.doctorPublicId}`}>
                  <Link
                    href={
                      ROUTES.DOCTOR.DETAIL.path +
                      `/${doctor.doctorPublicId}?type=${viewModel.categoryType}&categoryId=${viewModel.categoryId}`
                    }
                  >
                    <a>
                      <NonF2fDoctorItem doctor={doctor} />
                      <div className={'h-[1px] w-full bg-gray-30'} />
                    </a>
                  </Link>
                </li>
              );
            })}
          </ul>
          <PaginationComponent
            baseUrl={ROUTES.TELEMEDICINE.DOCTORS.path}
            queries={viewModel.queries}
            currentPage={viewModel.currentPage}
            perPage={5}
            totalPage={viewModel.totalPage}
          />
        </div>
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};

export default TelemedicineDoctorsTemplate;

const HeaderSection = styled.section`
 ${({ theme }) => {
   return css`
       display: flex;
       gap: 12px;
       min-height: 60px;
       padding: 0 20px 0 24px;
       align-items: ${theme.client.isMobile ? 'flex-start' : 'center'};
       flex-direction: ${theme.client.isMobile ? 'column' : 'row'};
     `;
 }};
`;
